export default "__VITE_ASSET__ClwGIUds__"